import './TabPane.less'
import TabPane from './TabPane'
export default TabPane
